import { render, staticRenderFns } from "./MaintenanceModeBox.vue?vue&type=template&id=643669f6&scoped=true"
import script from "./MaintenanceModeBox.vue?vue&type=script&lang=js"
export * from "./MaintenanceModeBox.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceModeBox.vue?vue&type=style&index=0&id=643669f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643669f6",
  null
  
)

export default component.exports